import { Link } from "react-router-dom";
import { AppLayout } from "../../components/layout/Header";
import { useAuth } from "../../js/hooks/useAuth";
import { latestVerificationLink } from "../../js/auth/emailVerification";
import { issueVerificationToken } from "../../js/auth/emailVerification";
import { resolvePostAuthPath } from "../../js/auth/onboardingState";

export default function VerifyEmailPending() {
  const { session } = useAuth();
  const link = session?.userId ? latestVerificationLink(session.userId) : "";

  function resend() {
    if (!session?.userId) return;
    issueVerificationToken(session.userId, session.email);
    window.location.reload();
  }

  if (!session) {
    return (
      <AppLayout>
        <article className="card auth-card">
          <h1>Verify your email</h1>
          <p className="page-lead">Sign in first, then we can send a verification link.</p>
          <Link className="primary-btn" to="/login">
            Sign in
          </Link>
        </article>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <article className="card auth-card onboarding-card">
        <h1>Check your email</h1>
        <p className="page-lead">
          We queued a verification link for <strong>{session.email}</strong>. Confirm your address
          before continuing to your desk.
        </p>
        {link ? (
          <div className="onboarding-dev-link">
            <p className="muted">Until outbound mail is live, open this link on this device:</p>
            <a className="ghost-btn" href={link}>
              Verify email now
            </a>
          </div>
        ) : null}
        <div className="onboarding-actions">
          <button type="button" className="primary-btn" onClick={resend}>
            Resend link
          </button>
          <Link className="ghost-btn" to={resolvePostAuthPath(session)}>
            Continue
          </Link>
        </div>
      </article>
    </AppLayout>
  );
}
